
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'no-offer',
  templateUrl: './no-offer.component.html',
  standalone: true,
  imports: [ButtonModule, TranslateModule]
})
export class NoOfferComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}